/**
 * Session-storage prefill for the /contact form's `area_of_interest` field.
 *
 * Each `/platform/<sub>` route that maps to an enum calls `usePrefillArea(enum)`
 * on mount, writing the value to sessionStorage. The Contact page reads it
 * on mount as the default select value, and clears it after a successful
 * submit. Silent — no UI indicator.
 */
import { useEffect } from "react";

const KEY = "frac.contact.prefill.area";

export function usePrefillArea(area) {
  useEffect(() => {
    if (typeof window === "undefined" || !area) return;
    try {
      window.sessionStorage.setItem(KEY, area);
    } catch {
      // sessionStorage may be unavailable (e.g. Safari private mode). Fail silent.
    }
  }, [area]);
}

export function readPrefillArea() {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function clearPrefillArea() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
